<template>
  <div class='layout'>
    <v-search :formContent='formContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
              @resetFn='resetFn'
              @searchFn='getListFn' @confirmFn='getListFn' @delFn='delFn' />
    <div class='componentPage'>
      <messageTable ref='publicTable' :tableData='tableData' :loading='loading' @choozeTable='choozeTable'
                    @handledelete='handledelete' @details='details' />
      <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                  :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
      <messageDialog :isShow.sync='isShow' :title='title' :detailObj='detailObj' />
    </div>
  </div>
</template>

<script>
import { deletemessage, messageDetail, messaglog } from '@/api/journal'
import mixinForm from '@/utils/formMixins.js'
import messageTable from './messageTable.vue'
import messageDialog from './messageDetail.vue'
import { getIsSys } from '@/utils/permission'

export default {
  components: {
    messageTable,
    messageDialog
  },
  mixins: [mixinForm],
  computed: {
    isSys () {
      return getIsSys()
    }
  },
  data () {
    return {
      SearchForm: {
        mobile: '',
        type: '',
        status: '',
        from: '',
        to: '',
        archName: '',
        scene_name: ''
      },
      formContent: [
        {
          id: 1,
          text: this.$t('public.table_arch'),
          type: 'input',
          paramsName: 'archName',
          isChooze: true
        },
        {
          id: 2,
          text: this.$t('noticelog.type'),
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: [
            {
              value: '',
              label: this.$t('public.please')
            },
            {
              value: '1',
              label: this.$t('noticelog.type_alarm')
            }
          ]
        },
        {
          id: 3,
          text: this.$t('noticelog.send_status'),
          type: 'select',
          paramsName: 'status',
          isChooze: false,
          selectParam: [
            {
              value: '',
              label: this.$t('public.please')
            },
            {
              value: '0',
              label: this.$t('noticelog.send_fail')
            },
            {
              value: '1',
              label: this.$t('noticelog.send_success')
            }
          ]
        },
        {
          id: 4,
          text: this.$t('public.phone_num'),
          type: 'input',
          paramsName: 'mobile',
          isChooze: false
        },
        {
          id: 5,
          text: this.$t('public.start_time'),
          type: 'datetime',
          paramsName: 'from',
          isChooze: false
        },
        {
          id: 6,
          text: this.$t('public.end_time'),
          type: 'datetime',
          paramsName: 'to',
          isChooze: false
        },
        {
          id: 7,
          text: this.$t('public.table_scope'),
          type: 'input',
          paramsName: 'scene_name',
          isChooze: false
        }
      ],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: this.$t('public.btn_delete'),
          method: 'delFn'
        }
      ],
      detailObj: {},
      choozeTableData: []
    }
  },
  methods: {
    resetFn () {
      ;(this.SearchForm = {
        address: '',
        type: '',
        status: '',
        from: '',
        to: '',
        archName: '',
        scene_name: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      }),
      this.getListFn()
    },
    getListFn () {
      this.loading = true
      const query = { ...this.SearchForm }
      if (this.SearchForm.from) {
        query.from = this.$dateParseTime(this.SearchForm.from)
      }
      if (this.SearchForm.to) {
        query.to = this.$dateParseTime(this.SearchForm.to)
      }
      messaglog(query)
        .then(({
          result,
          pageInfo
        }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idAry = this.choozeTableData.map((item) => item.id).join(',')
      this.TODOTIPDEL({ idAry })
    },
    allDelFn () {
      this.TODOTIPDEL({ idAry: 'all' })
    },
    handledelete (row) {
      this.TODOTIPDEL({ idAry: row.id })
    },
    /**
     *
     * @param {*param 选中数据id} param string
     */
    TODOTIPDEL (param) {
      this.$confirm(
        this.$t('public.tip_confirm'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          deletemessage(param).then(({
            result,
            state
          }) => {
            if (result) {
              this.getListFn()
              this.$message.success(
                this.$t('public.tip_del_succ').toString()
              )
            } else {
              this.$message.error(state.msg)
            }
          })
        })
        .catch(() => {
        })
    },
    details (row) {
      this.isShow = true
      this.title = `[${row.sceneName}] ${this.$t('public.details')}`
      messageDetail(row.id).then(({ result }) => {
        this.detailObj = result
      })
    }
  },
  mounted () {
    if (!this.isSys) {
      const idx = this.formContent.findIndex(item => item.id === 7)
      if (idx !== -1) {
        this.formContent.splice(idx, 1)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  width: 100%;

  ::v-deep .el-form {
    padding-top: 0px !important;
  }
}

.componentPage {
  flex: 1;

  .pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
